// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 280 ? "main-b3964565" : chunkId) + ".css";
};